'use strict'

define ['./agents.css'], () ->
  (RentappService, $state, Raven) ->
    restrict: "E"
    template: require("./agents.jade")
    scope: {field: "=", mode: "@", apptemp: "=", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      scope.agent_username = ""

      url = new URL(window.location.href)
      if url.searchParams.get('a')
        try
          scope.agent_username = atob(url.searchParams.get('a'))
        catch
          scope.agent_username = ""

      scope.update = (agent) ->
        scope.field.value = agent.value
        scope.selected_agent = agent.label

        if scope.agent_username and agent.value != scope.agent_username
          message = "Applicant updated mapped agent field value on #{window.location.href}: mapped agent: #{scope.agent_username}, applicant selected: #{agent.value}"
          Raven.captureMessage(message, { level: 'info' })

      agent = _.find(scope.field.choices, {'value': scope.field.value})

      if agent
        scope.agent_name = agent['label']
        scope.agent_options = scope.field.choices
        scope.selected_agent = agent
      # TODO: Refactor
      # For legacy apps that do not have agent field choices filled, 
      # look at apptemplate object that is passed down.
      else
        scope.agent_options = scope.apptemp.company_agents

        if scope.agent_username
          mapped_agent = _.find(scope.agent_options, {'value': scope.agent_username })

          if mapped_agent
            scope.field.value = scope.agent_username
            scope.selected_agent = mapped_agent.label

      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/agents/agents.coffee